import React, { useState, useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import SeoPageContent from '@/components/seo/SeoPageContent';
import applyPageMetadata from '@/components/seo/pageMetadata';
import { base44 } from '@/api/base44Client';


export default function SammenlignPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    setPage(null);
    base44.entities.SEOPage.filter({ slug, status: 'published' }, { limit: 1 })
      .then(({ items }) => {
        if (cancelled) return;
        const found = items[0];
        if (!found) { setNotFound(true); return; }
        setPage(found);
        applyPageMetadata({title: found.title, description: found.meta_description || found.intro_text || found.h1, path: `/sammenlign/${found.slug}`});
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-[#1a2e1a] rounded-full animate-spin" />
      </div>
    );
  }

  // Any slug that isn't a live published page (e.g. archived GNP Energy pages)
  // redirects to the main comparison page to preserve organic traffic.
  if (notFound) {
    return <Navigate to="/elpris-sammenligning" replace />;
  }

  return page ? <SeoPageContent page={page} /> : null;
}